<template functional>
  <svg
    v-tooltip.right="$options.methods.getTooltip(props)"
    viewBox="0 0 24 24"
    class="icon"
    :class="$options.methods.getStyleClasses(props)"
    v-bind="data.attrs"
    role="presentation"
    v-on="listeners"
  >
    <svg
      v-if="props.name !='olymp-star-icon'"
      :viewBox="$options.methods.getViewBox(props)"
      preserveAspectRatio="xMidYMid meet"
    >
      <title>{{ props.title || props.name }}</title>
      <desc v-if="props.desc">{{ props.desc }}</desc>
      <!-- eslint-disable vue/no-v-html -->
      <g
        v-if="props.name != 'olymp-headphones-icon' && props.name != 'olymp-cupcake-icon' && props.name != 'olymp-magnifying-glass-icon' && props.name !='olymp-star-icon'"
        :transform="$options.methods.getTransform(props)"
        class="icon1"
        :class="$options.methods.getStyleClasses(props)"
        stroke="none"
        v-html="$options.methods.getPaths(props)"
      />
      <path
        v-if="props.name == 'olymp-headphones-icon'"
        d="M9.792 17.78c0.491 0 0.889 0.398 0.889 0.889v8.891c0 0.489-0.398 0.885-0.889 0.885s-0.889-0.396-0.889-0.885v-8.891c0-0.491 0.398-0.889 0.889-0.889zM9.792 14.224c-2.452 0-4.444 1.995-4.444 4.444v8.891c0 2.448 1.993 4.441 4.444 4.441s4.444-1.993 4.444-4.441v-8.891c0-2.45-1.993-4.444-4.444-4.444v0z"
      />
      <path
        v-if="props.name == 'olymp-headphones-icon'"
        d="M6.972 26.597c-1.883-0.075-3.388-1.612-3.388-3.515s1.508-3.44 3.388-3.515v-3.556c-3.861 0.078-6.972 3.218-6.972 7.099s3.111 7.020 6.972 7.097v-3.611z"
      />
      <path
        v-if="props.name == 'olymp-headphones-icon'"
        d="M25.762 17.78c0.491 0 0.889 0.398 0.889 0.889v8.891c0 0.489-0.398 0.885-0.889 0.885s-0.889-0.396-0.889-0.885v-8.891c0-0.491 0.398-0.889 0.889-0.889zM25.762 14.224c-2.452 0-4.444 1.995-4.444 4.444v8.891c0 2.448 1.993 4.441 4.444 4.441 2.45 0 4.443-1.993 4.443-4.441v-8.891c0-2.45-1.993-4.444-4.443-4.444v0z"
      />
      <path
        v-if="props.name == 'olymp-headphones-icon'"
        d="M28.583 26.597c1.883-0.075 3.388-1.612 3.388-3.515s-1.508-3.44-3.388-3.515v-3.556c3.861 0.078 6.972 3.218 6.972 7.099s-3.111 7.020-6.972 7.097v-3.611z"
      />
      <path
        v-if="props.name == 'olymp-headphones-icon'"
        d="M4.404 9.426c-0.539 1.5-0.848 3.111-0.848 4.796v4.686h3.556v-4.686c0-0.942 0.135-1.851 0.364-2.72l-3.072-2.076z"
      />
      <path
        v-if="props.name == 'olymp-headphones-icon'"
        d="M17.778 0c-1.687 0-3.298 0.309-4.8 0.848l2.069 3.074c0.875-0.231 1.785-0.366 2.731-0.366 5.883 0 10.667 4.784 10.667 10.667v4.686h3.556v-4.686c0-7.854-6.368-14.222-14.222-14.222z"
      />
      <path
        v-if="props.name == 'olymp-headphones-icon'"
        d="M7.148 3.518h3.556v3.556h-3.556v-3.556z"
      />

      <path
        v-if="props.name == 'olymp-cupcake-icon'"
        d="M5.349 32h3.984v-2.667h-1.671l-0.933-6.541 12.959-0.063 0.312-0.063h-15.979z"
      />
      <path
        v-if="props.name == 'olymp-cupcake-icon'"
        d="M20 22.667l-0.963 6.667h-1.704v2.667h4.016l1.339-9.333z"
      />
      <path
        v-if="props.name == 'olymp-cupcake-icon'"
        d="M25 12.908c-0.921-2.695-3.583-4.743-7.667-4.891v2.673c2.639 0.121 4.513 1.237 5.143 3.080 0.157 0.457 0.435 0.864 0.805 1.176 0.451 0.379 0.719 1.028 0.719 1.737 0 0.649-0.232 1.251-0.635 1.648-0.377 0.372-0.636 0.849-0.74 1.368-0.195 0.957-1.133 1.651-2.203 1.652-0.375-0.047-1.288-0.669-1.587-0.873-0.447-0.305-0.972-0.464-1.503-0.464-0.173 0-0.347 0.017-0.519 0.051-0.7 0.139-1.317 0.553-1.709 1.151-0.605 0.919-1.267 1.468-1.772 1.468-0.596 0-1.305-0.757-1.771-1.467-0.392-0.597-1.008-1.013-1.709-1.152-0.173-0.033-0.347-0.049-0.52-0.049-0.531 0-1.055 0.159-1.5 0.463-0.301 0.204-1.216 0.828-1.557 0.873-1.101 0-2.040-0.695-2.233-1.651-0.105-0.52-0.363-0.996-0.74-1.368-0.405-0.4-0.636-1-0.636-1.649 0-0.709 0.268-1.359 0.717-1.736 0.371-0.312 0.649-0.719 0.805-1.177 0.588-1.716 2.545-2.885 5.144-3.079v-2.675c-3.924 0.225-6.751 2.212-7.667 4.891-1.005 0.847-1.667 2.217-1.667 3.776 0 1.428 0.561 2.691 1.427 3.545 0.436 2.157 2.437 3.789 4.848 3.789 1.073 0 2.248-0.784 3.059-1.336 0.871 1.327 2.227 2.669 4 2.669s3.128-1.343 4-2.669c0.809 0.552 1.984 1.336 3.059 1.336 2.411 0 4.412-1.632 4.848-3.789 0.865-0.856 1.427-2.117 1.427-3.545 0-1.559-0.661-2.929-1.667-3.776z"
      />
      <path
        v-if="props.name == 'olymp-cupcake-icon'"
        d="M12 29.333h2.667v2.667h-2.667v-2.667z"
      />
      <path
        v-if="props.name == 'olymp-cupcake-icon'"
        d="M12 13.332h2.667v-8h-2.667v8zM13.333 0c-0.737 0-1.333 0.596-1.333 1.332v1.333c0 0.736 0.596 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-1.333c0-0.736-0.596-1.332-1.333-1.332z"
      />

      <path
        v-if="props.name == 'olymp-magnifying-glass-icon'"
        d="M20.809 3.57c-4.76-4.76-12.478-4.76-17.239 0s-4.76 12.48 0 17.239c4.76 4.76 12.48 4.76 17.239 0 4.76-4.759 4.76-12.478 0-17.239zM18.654 18.654c-3.57 3.57-9.361 3.57-12.93 0-3.57-3.57-3.57-9.359 0-12.93s9.361-3.57 12.93 0c3.57 3.569 3.57 9.359 0 12.93z"
      />
      <path
        v-if="props.name == 'olymp-magnifying-glass-icon'"
        d="M24.022 21.907l2.154-2.156 2.157 2.155-2.154 2.156-2.157-2.155z"
      />
      <path
        v-if="props.name == 'olymp-magnifying-glass-icon'"
        d="M28.34 28.364c-0.596 0.597-1.559 0.597-2.155 0l-6.464-6.464-0.834-0.852 4.3-4.3-1.312-1.314-6.466 6.466 8.62 8.619c1.783 1.783 4.683 1.783 6.464 0 1.783-1.781 1.783-4.681 0-6.464l-2.155 2.155c0.596 0.596 0.594 1.562 0 2.155z"
      />

      <path
        v-if="props.name == 'olymp-star-icon'"
        d="M24.029 27.192h3.2v3.2h-3.2v-3.2z"
      />
      <path
        v-if="props.name == 'olymp-star-icon'"
        d="M31.88 11.91c-0.275-0.826-0.984-1.43-1.837-1.562l-8.309-1.28-3.611-7.763c-0.379-0.816-1.194-1.336-2.090-1.336-0.893 0-1.707 0.522-2.086 1.336l-3.613 7.763-8.309 1.28c-0.854 0.131-1.563 0.736-1.838 1.562-0.275 0.827-0.067 1.739 0.536 2.36l6.088 6.298-1.413 8.731c-0.142 0.88 0.226 1.762 0.947 2.277 0.397 0.28 0.862 0.424 1.328 0.424 0.384 0 0.766-0.098 1.115-0.291l7.243-4.037 4.768 2.656v-3.662l-4.768-2.658-7.184 4.005 1.378-8.517-1.114-1.154-4.922-5.090 8.323-1.282 0.723-1.552 2.798-6.014 3.52 7.566 8.326 1.283-6.038 6.243 0.733 4.53h3.242l-0.56-3.458 6.091-6.298c0.6-0.622 0.806-1.534 0.531-2.362z"
      />

      <path
        v-if="props.name == 'olymp-accordion-open-icon'"
        d="M32 12.8v6.4H0v-6.4h32z"
      />
      <path
        v-if="props.name == 'olymp-accordion-open-icon'"
        d="M19.2 32h-6.4V0h6.4v32z"
      />
      <path
        v-if="props.name == 'olymp-accordion-close-icon'"
        d="M32 12.8v6.4H0v-6.4h32z"
      />



    </svg>
  </svg>
</template>

<script>
  import icons from './icons-multiple.json';

  export default {
    name: "AppIconMultiple",
    props: {
      name: {
        type: String,
        default: ''
      },
      size: {
        type: String,
        default: ''
      },
      color: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      desc: {
        type: String,
        default: ''
      },
      tooltip: {
        type: String,
        default: ''
      },
      otherclass: {
        type: String,
        default: ''
      }
    },
    methods: {
      getTooltip(props) {
        return props.tooltip || '';
      },
      getViewBox(props) {
        if (props.name == 'nico-books-icon' || props.name == 'nico-food-icon') {
          return '0 0 1600.000000 1600.000000';
        } else if (props.name == 'nico-video-icon') {
          return '0 0 512.000000 512.000000';
        } else if (props.name == 'olymp-headphones-icon') {
          return '0 0 36 32';
        } else if (props.name == 'olymp-magnifying-glass-icon') {
          return '0 0 34 32';
        } else if (props.name == 'olymp-accordion-open-icon' || props.name == 'olymp-accordion-close-icon' ) {
          return '0 0 32 32';
        } else if (props.name == 'olymp-cupcake-icon') {
          return '0 0 27 32';
        } else if (props.name == 'nico-contact-icon') {
          return '0 0 225.000000 225.000000';
        } else if (props.name == 'olymp-star-icon') {
          return '0 0 576 512';
        } else {
          return '0 0 203.000000 249.000000';
        }
      },
      getTransform(props) {
        if (props.name == 'nico-books-icon' || props.name == 'nico-food-icon') {
          return 'translate(0.000000,1600.000000) scale(0.100000,-0.100000)';
        } else if (props.name == 'nico-video-icon') {
          return 'translate(0.000000,512.000000) scale(0.100000,-0.100000)';
        } else if (props.name == 'nico-contact-icon') {
          return 'translate(0.000000,225.000000) scale(0.100000,-0.100000)';
        } else {
          return 'translate(0.000000,249.000000) scale(0.100000,-0.100000)';
        }
      },
      getCount(props) {
        return icons[props.name].length;
      },
      getPaths(props) {
        return icons[props.name];
      },
      getStyleClasses(props) {
        // return [props.size, props.color].map(val => val && `is-${val}`);

        return `${props.otherclass} is-${props.size} is-${props.color}`;
      },
    },
  };
</script>

<style>
  /* default */
  .icon {
    width: 1.2em;
    height: 1.2em;
    fill: currentColor;
  }

  /* sizes */
  .icon.is-large {
    width: 2em;
    height: 2em;
  }
  .icon.is-medium {
    width: 1.6em;
    height: 1.6em;
  }
  .icon.is-normal {
    width: 1.2em;
    height: 1.2em;
  }
  .icon.is-small {
    width: 1em;
    height: 1em;
  }
  .icon.is-tiny {
    width: 0.8em;
    height: 0.8em;
  }

  /* colors */
  .icon.is-primary,
  .icon.is-blue {
    fill: #2196F3
  }
  .icon.is-success,
  .icon.is-green {
    fill: #4CAF50
  }
  .icon.is-danger,
  .icon.is-red  {
    fill: #F44336
  }
  .icon.is-warning,
  .icon.is-orange {
    fill: #FF9800
  }
  .icon.is-gray, .icon1.is-gray {
    fill: #9a9fbf
  }
  .icon.is-white, .icon1.is-white {
    fill: #ffffff;
  }
  .icon.is-dark-gray, .icon1.is-dark-gray {
    fill: #3f4257;
  }
  .icon.is-black, .icon1.is-black {
    fill: #000000;
  }
</style>